import script from "./VehicleDetailsView.vue?vue&type=script&setup=true&lang=js"
export * from "./VehicleDetailsView.vue?vue&type=script&setup=true&lang=js"

import "./VehicleDetailsView.vue?vue&type=style&index=0&id=14115012&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14115012"]])

export default __exports__